import React from 'react'
import Footer from '../components/Footer'
import Header from '../components/Header'
function Contact() {
    return (
        <div>
        <Header/>
            <div className='container contact mt-5 '></div>
            <div className='row pt-5'>
                <div className='col-md-6 '>
                    <img src="./contactus.png" alt='' style = {{width:"700px"}}></img>
                </div>
                <div className='col-md-6'>
                    <div className='contact-form m-2 p-5 n-box2'>
                        <input type={'text'} className='form-control' placeholder='Name' />
                        <input type={'text'} className='form-control' placeholder='Name' />
                        <textarea className="form-control" row={3} defaultValue={""} />
                        <button className='primary-button tempbtn'>SUBMIT</button>
                    </div>
                </div>
            </div>
            <Footer/>
        </div>
    )
}

export default Contact
